(function () {
    'use strict';
    angular.module('app').controller('selectiontree', selectiontree);
    selectiontree.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'SelectionCommand_WorkflowService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'selectionCommandService'];
    function selectiontree($location, scope, $rootScope, gridDataService, $q, SelectionCommand_WorkflowService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, selectionCommandService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_ASSIGN = 121;
        scope.xyz = { bReadyForOK: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];


        // =====================================
        //
        // =====================================  


        // On click of the Assign button.
        scope.onSelectionTreeButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_ASSIGN;
            // PL-OBS? scope.xyz = { bReadyForOK: false, selectedUserItem: {} };

            selectionCommandService.GetSelectionTreeXml(1, slx).then(function(response){
                scope.xyz.xml = response.data;
            }, function (response) {
                selectionCommandService.ShowEx(response); // Nothing more to do.
            });

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }];

            // dialog config
            scope.heading = "Selection Tree";
            scope.filesLabel = "Files";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.slx.list, function (item) {
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename, library: item.detailedInfo.libName
                });
                index++;
            });

            $timeout(function () {
                refreshGrid();
                scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
        };

      

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onSelectionTreeDialogOK = function () {
            scope.xyz.processing = true;

            // Close dialog and refresh grid.
            $mdDialog.hide();
            scope.xyz.processing = false;
        };

        scope.onSelectionTreeDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.assignDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            //after the grid has been initialized
            switch (command) {
                case "selectiontree":
                    scope.onSelectionTreeButtonClicked(records);
                    break;
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
